import { useEffect } from "react";
import "./StudentDetail.css";
import QuestTable from "./QuestTable";
import { useParams } from "react-router-dom";
import StudentCard from "./StudentCard";
import { useGetStudentReportById } from "../../../../hooks/teacher/students/useGetStudentReportById";
import TableError from "../../common/TableError";
import StudentCardSkeleton from "./StudentCardSkeleton";
import TableSkeleton from "../../common/TableSkeleton";
import BackButton from "../../../common/BackButton";

const StudentDetail = () => {
  const { id } = useParams();
  const { report, loading, error, getStudentReportById } =
    useGetStudentReportById();

  useEffect(() => {
    getStudentReportById({ studentId: id });
  }, [id]);

  if (loading && report === undefined) {
    return (
      <div>
        <div className="pb-2">
          <BackButton />
        </div>
        <StudentCardSkeleton />
        <TableSkeleton rows={5} columns={5} />
      </div>
    );
  }

  if (error || report === null) {
    return (
      <TableError
        error={error}
        handleRefresh={() => getStudentReportById({ studentId: id })}
        loading={loading}
      />
    );
  }

  const student = {
    name: report?.student?.name,
    studentId: report?.student?.student_code,
    age: report?.student?.age,
    email: report?.student?.email,
    progress: report?.student?.overall_progress,
    avgScore: report?.student?.avg_quiz_score,
    totalQuests: report?.student?.total_quests_assigned,
    username: report?.student?.username,
  };

  const questsByCategory = report?.quests_by_category || {};
  const hasQuests = Object.keys(questsByCategory).length > 0;

  return (
    <div className="">
      <div className="pb-2">
        <BackButton />
      </div>
      <StudentCard student={student} />

      {hasQuests ? (
        Object.entries(questsByCategory).map(([category, quests]) => (
          <div className="lesson-text pt-4" key={category}>
            <h5 className="pb-2">
              Lesson: <span>{category}</span>
            </h5>
            <QuestTable quests={quests} studentId={id} student={student} />
          </div>
        ))
      ) : (
        <div className="alert alert-info mt-4" role="alert">
          No quests assigned to this student yet.
        </div>
      )}
    </div>
  );
};

export default StudentDetail;
